import type { LigneDroits } from '../../lib/equipeApi';
import { formatDateHeureFr } from '../../lib/formatDate';

/** Résumé en une phrase (maquette L02-02, L02-03) : « Camille pourra gérer le planning, sans voir les salaires. » */
export const phraseDroits = (prenom: string, lignes: Partial<LigneDroits>[], libelles: Record<string, string>, salairesAccordes = false): string => {
    const nom = (l: Partial<LigneDroits>) => (libelles[l.module_name || ''] || l.module_name || '').toLowerCase();
    const gerer = lignes.filter((l) => l.modifier || l.creer).map(nom);
    const consulter = lignes.filter((l) => l.voir && !l.modifier && !l.creer).map(nom);
    const liste = (a: string[]) => (a.length > 2 ? `${a.slice(0, 2).join(', ')} et ${a.length - 2} autre${a.length - 2 > 1 ? 's' : ''}` : a.join(' et '));
    const morceaux: string[] = [];
    if (gerer.length) morceaux.push(`gérer ${liste(gerer)}`);
    if (consulter.length) morceaux.push(`consulter ${liste(consulter)}`);
    let s = `${prenom} ${morceaux.length ? `pourra ${morceaux.join(' et ')}` : "n'aura accès à aucun module pour l'instant"}`;
    if (!salairesAccordes) s += ', sans voir les salaires';
    return `${s}.`;
};

export const prenomDe = (nom: string) => nom.trim().split(/\s+/)[0] || nom;
export const initiales = (nom: string) => nom.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase() || '').join('');
/** Date et heure au format de l'application (jj/mm/aaaa hh:mm) ; « Jamais connecté » si vide. */
export const dateCourte = (iso: string | null) => (iso ? formatDateHeureFr(iso) : 'Jamais connecté');
